(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["style/hi-res-button-styles"] = factory();
	else
		root["style/hi-res-button-styles"] = factory();
})(globalThis, () => {
return 